import React from 'react';
import CodeBlock from './CodeBlock';
import CodeSuggestionsTable from './CodeSuggestionsTable';
import { parseMessageContent, extractFilename } from '../../utils/messageParser';

const MessageContent = ({ content }) => {
  // Check if content is a structured object with suggestions
  if (typeof content === 'object' && content.type === 'code-suggestions') {
    return (
      <div className="message-content">
        {content.text && (
          <div className="text-content">
            {content.text}
          </div>
        )}
        <CodeSuggestionsTable 
          suggestions={content.suggestions}
          context={content.context}
        />
        {content.tokensUsed && (
          <div className="final-token-count">
            <span className="token-icon">🪙</span>
            <span>Total tokens used: {content.tokensUsed.toLocaleString()}</span>
          </div>
        )}
      </div>
    );
  }

  // Otherwise, parse as regular content
  const parts = parseMessageContent(content);

  return (
    <div className="message-content">
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return (
            <div key={index} className="text-content">
              {part.content.split('\n').map((line, lineIndex) => (
                <React.Fragment key={lineIndex}>
                  {line}
                  {lineIndex < part.content.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </div>
          );
        } else if (part.type === 'code') {
          const filename = extractFilename(part.content, part.language);
          return (
            <CodeBlock
              key={index}
              code={part.content}
              language={part.language}
              filename={filename}
              isDiff={part.isDiff}
            />
          );
        }
        return null;
      })}
    </div>
  );
};

export default MessageContent; 